import styled from 'styled-components';

interface FjFlexItemProps {
  flex?: string;
  flexBasis?: string;
  justifyContent?: string;
  flexShrink?: string;
}

const FjFlexItem = styled('div')<FjFlexItemProps>`
  display: flex;
  flex: ${(props) => props.flex || '1 1 0'};
  align-self: center;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
`;

export default FjFlexItem;
